export const SURE_TYPE_FEATURES_POLICY_REQUESTING = 'SURE_TYPE_FEATURES_POLICY_REQUESTING';
export const SURE_TYPE_FEATURES_POLICY_SUCCESS = 'SURE_TYPE_FEATURES_POLICY_SUCCESS';
export const SURE_TYPE_FEATURES_POLICY_ERROR = 'SURE_TYPE_FEATURES_POLICY_ERROR';